import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import UPInput from 'components/input';
import {
  CONTRACTS__COST_CENTER,
  CONTRACTS__GENERAL,
  GENERAL__NAME,
  GENERAL__WORKERCLASS,
  COMPANY_PAYROLL__FUNCTION,
  CONTRACTS__COMPANY_LOCATION,
} from 'translations/constants';
import { getWorkerclassLabelFromCode } from 'utils/helpers';
import { SectionCard, SectionTitle, SectionDivider } from '../styles';

interface GeneralSectionProps {
  employeeName: string;
  statute: string;
  locationName: string;
  functionName: string;
  costCenterName: string;
}

const GeneralSection = (props: GeneralSectionProps) => {
  const { employeeName, statute, locationName, functionName, costCenterName } = props;
  const { t } = useTranslation();

  return (
    <SectionCard>
      <SectionTitle>{t(CONTRACTS__GENERAL)}</SectionTitle>
      <SectionDivider />
      <Box display="flex" gap={2}>
        <UPInput
          value={employeeName}
          onChange={null}
          placeholder=""
          label={t(GENERAL__NAME)}
          disabled
          id="detail-panel-employee-name"
        />
        <UPInput
          value={getWorkerclassLabelFromCode(statute)}
          onChange={null}
          placeholder=""
          label={t(GENERAL__WORKERCLASS)}
          disabled
          id="detail-panel-statute"
        />
      </Box>
      <Box display="flex" gap={2}>
        <UPInput
          value={costCenterName}
          onChange={null}
          placeholder=""
          label={t(CONTRACTS__COST_CENTER)}
          disabled
          id="detail-panel-cost-center"
        />
        <UPInput
          value={locationName}
          onChange={null}
          placeholder=""
          label={t(CONTRACTS__COMPANY_LOCATION)}
          disabled
          id="detail-panel-location"
        />
        {statute !== 'Permanent' && (
          <UPInput
            value={functionName}
            onChange={null}
            placeholder=""
            label={t(COMPANY_PAYROLL__FUNCTION)}
            disabled
            id="detail-panel-function"
          />
        )}
      </Box>
    </SectionCard>
  );
};

export default GeneralSection;
